var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stateHeader ml15 mr15 pl10 pt10 pb10 fs18 flex aic"},[_c('span',{staticClass:"mr10"},[_vm._v("状态:")]),_vm._v("  "+_vm._s(_vm.formatState)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }